import { Link } from 'react-router';
import { BrandName } from '../brand/BrandName';
import { LogoMark } from '../brand/LogoMark';
import { siteConfig } from '../../config/site';
import { buildWhatsAppUrl } from '../../lib/whatsapp';

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="shell site-footer__grid">
        <div>
          <Link className="wordmark wordmark--light" to="/">
            <span className="wordmark__mark"><LogoMark /></span>
            <BrandName light />
          </Link>
          <p>Independent web studio</p>
        </div>
        <div>
          <h2>Navigate</h2>
          <Link className="link-underline" to="/#services">Services</Link>
          <Link className="link-underline" to="/work">Work</Link>
          <Link className="link-underline" to="/process">Process</Link>
          <Link className="link-underline" to="/about">About</Link>
          <Link className="link-underline" to="/contact">Contact</Link>
          <Link className="link-underline" to="/white-label">For Agencies</Link>
        </div>
        <div>
          <h2>Contact</h2>
          <a className="link-underline" href={`mailto:${siteConfig.email}`}>{siteConfig.email}</a>
          <a className="link-underline" href={buildWhatsAppUrl(siteConfig.defaultWhatsAppMessage)} target="_blank" rel="noreferrer">WhatsApp</a>
          <a className="link-underline" href={siteConfig.linkedinUrl} target="_blank" rel="noreferrer">LinkedIn</a>
          <p>Remote collaboration worldwide.</p>
        </div>
        <div>
          <h2>Legal</h2>
          <Link className="link-underline" to="/privacy">Privacy</Link>
          <Link className="link-underline" to="/terms">Terms</Link>
        </div>
      </div>
      <div className="shell site-footer__bottom">
        <span>© {new Date().getFullYear()} Malev Studio</span>
      </div>
    </footer>
  );
}
